import { __awaiter } from "tslib";
import { ConfigurationChangeEvent } from "@plansoft-configuration-renderer/events";
import { handleConfigurationEvent } from "../events/handleConfigurationEvent";
import { getSessionId } from "../reducers/selectors";
import { cfgStateThunkAction } from "./cfgStateThunkAction";
/**
 * Invoke user defined function
 *
 * Called from various other async thunks initiating a reset
 *
 * @param options
 * @returns
 */
export function invokeUserDefinedFunction(options) {
    return (dispatch_1, getState_1, _a) => __awaiter(this, [dispatch_1, getState_1, _a], void 0, function* (dispatch, getState, { cfgApi }) {
        const id = getSessionId(getState());
        const response = yield dispatch(cfgStateThunkAction(() => cfgApi.invokeUserDefinedFunction({
            id,
            name: options.name,
            invokeUserDefinedFunctionParams: options.params,
        })));
        dispatch(handleConfigurationEvent(new ConfigurationChangeEvent(id)));
        return response;
    });
}
//# sourceMappingURL=invokeUserDefinedFunction.js.map